module.exports = __webpack_public_path__ + "static/media/IMG_1745 2.f5203b50.png";